import { render } from "./ShareLinkPreviewCard.vue?vue&type=template&id=46c8572b&scoped=true"
import script from "./ShareLinkPreviewCard.vue?vue&type=script&lang=js"
export * from "./ShareLinkPreviewCard.vue?vue&type=script&lang=js"

import "./ShareLinkPreviewCard.vue?vue&type=style&index=0&id=46c8572b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c8572b"]])

export default __exports__